// extracted by mini-css-extract-plugin
export default {"header":"_92a0192f","ampHeader":"_174a6c93"};